import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import PopupWithSidebar from "../../../../components/Popups/PopupWithSidebar/PopupWithSidebar.tsx";
import AutomotiveBestPracticesContent from "./Content/AutomotiveBestPracticesContent.tsx";

export type AutomotiveBestPracticesPopupProps = {
	open: boolean;
	onClose: () => void;
};

const AutomotiveBestPracticesPopup = ({ open, onClose }: AutomotiveBestPracticesPopupProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.automotive.models.popups.bestPractices" });

	const sideMenuButtons = [
		{
			title: t("taps.overview.title"),
			id: t("taps.overview.id"),
		},
		{
			title: t("taps.prepareYourImage.title"),
			id: t("taps.prepareYourImage.id"),
		},
		{
			title: t("taps.sceneDescription.title"),
			id: t("taps.sceneDescription.id"),
		},
		{
			title: t("taps.addEnhancements.title"),
			id: t("taps.addEnhancements.id"),
			subTabs: [
				{
					title: t("taps.addEnhancements.subTabs.generateReflections.title"),
					id: t("taps.addEnhancements.subTabs.generateReflections.id"),
				},
				{
					title: t("taps.addEnhancements.subTabs.wheelsRefinement.title"),
					id: t("taps.addEnhancements.subTabs.wheelsRefinement.id"),
				},
				{
					title: t("taps.addEnhancements.subTabs.generateEffects.title"),
					id: t("taps.addEnhancements.subTabs.generateEffects.id"),
				},
				{
					title: t("taps.addEnhancements.subTabs.generateHarmonization.title"),
					id: t("taps.addEnhancements.subTabs.generateHarmonization.id"),
				},
				{
					title: t("taps.addEnhancements.subTabs.modifyObjectsRemove.title"),
					id: t("taps.addEnhancements.subTabs.modifyObjectsRemove.id"),
				},
				{
					title: t("taps.addEnhancements.subTabs.expandAspectRatio.title"),
					id: t("taps.addEnhancements.subTabs.expandAspectRatio.id"),
				},
				{
					title: t("taps.addEnhancements.subTabs.additionalNotes.title"),
					id: t("taps.addEnhancements.subTabs.additionalNotes.id"),
				},
			],
		},
	];
	const handleCloseDialog = () => {
		localStorage.removeItem("guidelineActiveTap");
		onClose();
	};

	return (
		<PopupWithSidebar
			sideMenuButtons={sideMenuButtons}
			selectedLink={localStorage.getItem("guidelineActiveTap")}
			handleCloseDialog={handleCloseDialog}
			open={open}
		>
			<AutomotiveBestPracticesContent onClose={handleCloseDialog} />
		</PopupWithSidebar>
	);
};

export default observer(AutomotiveBestPracticesPopup);
